import { useEffect, useState } from "react";
import { getApi } from "../../ApiServices/api";
import { apiEndPoints } from "../../ApiServices/config";

const useYouthTruth = () => {
  const [youthTruth, setYouthTruth] = useState(null);

  const getYouthTruth = async () => {
    try {
      const response = await getApi(apiEndPoints.allYouthTruth);
      if (response && response.status === 200) {
        setYouthTruth(response?.data?.[0]);
      }
    } catch (error) {
      console.error("Error fetching Youth & Truth data:", error);
    }
  };

  useEffect(() => {
    getYouthTruth();
  }, []);

  return {youthTruth};
};

export default useYouthTruth;